import styled from "styled-components";
import Box from "../box";
const Header = styled(Box).withConfig({
  displayName: "header__Header",
  componentId: "sc-46awro-0"
})([""]);
Header.defaultProps = {
  as: "header",
  fixed: false
};
export default Header;